import { useState, FormEvent } from 'react'

import { useRouter } from 'next/router'

import { useInputValidation } from '@/hooks'
import { usePageContext } from '@/store/pageContext'
import { phoneMask } from '@/utils/masks'

export const useFooterContainer = () => {
  const { darkMode } = usePageContext()
  const router = useRouter()

  const [contactFormData, setContactFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    company: '',
    message: '',
    phone: '',
  })
  const [newsletterFormData, setNewsletterFormData] = useState({
    email: '',
    lastname: '',
  })

  const [contactSubmitted, setContactSubmitted] = useState(false)
  const [newsletterSubmitted, setNewsletterSubmitted] = useState(false)

  const {
    handleBlur,
    handleTouched,
    handleErrorMessage,
    clearTouched,
    touched,
  } = useInputValidation()

  const handleContactFormChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setContactFormData({
      ...contactFormData,
      [event.target.name]: event.target.name.includes('phone')
        ? phoneMask(event.target.value, router.locale as 'pt-BR' | 'en')
        : event.target.value,
    })
    handleTouched(event.target.id)
  }

  const isContactFormEmpty = () =>
    !contactFormData.name.trim() ||
    !contactFormData.email.trim() ||
    !contactFormData.phone.trim()

  const isContactFormTouchedAndEmpty = () =>
    touched.name && touched.email && touched.phone && isContactFormEmpty()

  const handleNewsletterFormChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setNewsletterFormData({
      ...newsletterFormData,
      [event.target.name]: event.target.value,
    })
  }

  const isNewsletterFormEmpty = () => !newsletterFormData.email.trim()

  const handleContactSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (contactFormData.lastname) return
    setContactSubmitted(true)
    clearTouched()
  }

  const handleNewsletterSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (newsletterFormData.lastname) return
    setNewsletterSubmitted(true)
  }

  const handleSocialMediaClick = (url: string) => {
    window.open(url, '_blank')
  }

  return {
    darkMode,
    contactFormData,
    newsletterFormData,
    contactSubmitted,
    newsletterSubmitted,
    handleBlur,
    handleTouched,
    handleErrorMessage,
    handleContactFormChange,
    handleNewsletterFormChange,
    handleContactSubmit,
    handleNewsletterSubmit,
    handleSocialMediaClick,
    isContactFormEmpty,
    isContactFormTouchedAndEmpty,
    isNewsletterFormEmpty,
    touched,
    router,
  }
}
